import React from 'react'
import base64url from 'base64url'

import EkgRecordingReviewScreen from '../../containers/EkgRecordingReviewScreen'
import styles from './EkgReviewEkgRecording.css'
import queryString from 'query-string'

class EkgReviewEkgRecording extends React.Component {
  state = {
    inboxId: undefined,
    filters: {},
  }

  UNSAFE_componentWillMount() {
    const {
      match,
      location,
    } = this.props
    const queryParams = queryString.parse(location.search)
    const {
      inboxId,
    } = queryParams
    let { filters } = queryParams

    if (filters) {
      try {
        const decodedFilters = base64url.decode(filters)
        filters = JSON.parse(decodedFilters)
      } catch (err) {
        console.log(err)
      }
    }

    this.setState({
      filters,
      inboxId,
    })
    this.props.setInitialEkgReviewEkgRecordingData(match, inboxId, filters)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.match.params.recordingId !== prevProps.selectedRecordingId) {
      this.props.setInitialEkgReviewEkgRecordingData(this.props.match, this.state.inboxId, this.state.filters)
    }
  }

  componentWillUnmount() {
    this.props.clearSelectedRecordingId()
    this.props.clearSelectedReassignInboxId()
  }

  render() {
    const {
      match,
      selectedRecordingId,
      selectedReassignInboxId,
      selectedInboxId,
      recordingIds,
      updateSelectedReassignInboxId,
      removeFromStackCallback,
      confirmAndArchiveCallback,
      reassignCallback,
    } = this.props
    return (
      <div
        data-page="ekg-review-ekg-recording"
        className={styles.ekgReviewEkgRecording}
      >
        {selectedRecordingId &&
          <EkgRecordingReviewScreen
            showStackRemovalControl
            currentInboxId={selectedInboxId}
            recordingIds={recordingIds}
            recordingId={selectedRecordingId}
            reassignedInboxId={selectedReassignInboxId}
            updateReassignInboxId={updateSelectedReassignInboxId}
            removeFromStackCallback={removeFromStackCallback}
            confirmAndArchiveCallback={confirmAndArchiveCallback}
            reassignCallback={reassignCallback}
            match={match}
          />
        }
      </div>
    )
  }
}

export default EkgReviewEkgRecording



// WEBPACK FOOTER //
// ./src/legacy/pages/EkgReviewEkgRecording/EkgReviewEkgRecording.jsx